import { render } from "./changegender.vue?vue&type=template&id=0e04e82b&scoped=true"
import script from "./changegender.vue?vue&type=script&lang=js"
export * from "./changegender.vue?vue&type=script&lang=js"

import "./changegender.vue?vue&type=style&index=0&id=0e04e82b&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/xxiwant/lovestory/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e04e82b"]])

export default __exports__